import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Tab, Tabs } from 'react-bootstrap';
import { storage } from '../firebase/firebase';  // Import Firebase storage
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from "../config.js";
const Profile = () => {
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();
    const [isdisable, setIsDisable] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [phoneError, setPhoneError] = useState();
    const [emailError, setEmailError] = useState(false);
    const [userData, setUserData] = useState({
        display_name: '',
        email: '',
        mobile: '',
        state: '',
        pincode: '',
        photo_url: ""
    });


    useEffect(() => {
        const storedData = localStorage?.getItem('userData');

        if (storedData) {
            try {
                const decodedData = atob(storedData);
                const parsedData = JSON.parse(decodedData);

                setUserData({
                    display_name: parsedData.display_name || '',
                    email: parsedData.email || '',
                    mobile: parsedData.mobile || '',
                    state: parsedData.state || '',
                    pincode: parsedData.pincode || '',
                    id: parsedData?.id,
                    photo_url: parsedData?.photo_url
                });
            } catch (error) {
                console.error("Error parsing userData from localStorage:", error);
                localStorage.removeItem('userData');
            }
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPhoneError('');
        setEmailError('');

        if (name === "mobile") {
            if (!/^\d*$/.test(value)) return;

            if (value.length > 10) return;

            if (value.length === 10 && !/^[6789]\d{9}$/.test(value)) {
                setPhoneError('Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.');
            }
        }

        if (name === "email") {
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                setEmailError('Please enter a valid email address.');
            }
        }

        // Update state without blocking user input
        setUserData((prevData) => ({ ...prevData, [name]: value }));
    };


    const fileInputRef = useRef(null);
    const handleFileClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event) => {
        debugger
        const file = event.target.files[0];
        if (!file) return enqueueSnackbar("Please select an image!", { variant: 'warning' });
        setUploading(true);
        const storageRef = ref(storage, `profiles/${userData.id}-${Date.now()}`);

        try {
            await uploadBytes(storageRef, file);
            const imageUrl = await getDownloadURL(storageRef);
            const response = await axios.post(`${API_BASE_URL}/api/users/update-profile`, {
                id: userData.id,
                photo_url: imageUrl
            });

            if (response.status === 200) {
                const updatedUser = { ...userData, photo_url: imageUrl };
                setUserData(updatedUser);
                localStorage.setItem('userData', btoa(JSON.stringify(updatedUser)));
                enqueueSnackbar("Profile updated successfully!", { variant: "success" });
            }
        } catch (error) {
            console.error("Upload Error:", error);
            enqueueSnackbar("Error updating profile. Please try again.", { variant: "error" });
        } finally {
            setUploading(false);
        }
    };

    const addprofile = () => {
        setIsDisable(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger
        try {
            const response = await axios.post(`${API_BASE_URL}/api/users/update-profileDetails`, {
                id: userData.id,  // Ensure userId is valid
                display_name: userData.display_name,
                email: userData.email,
                mobile: userData.mobile,
                state: userData.state,
                pincode: userData.pincode
            });

            if (response.status === 200) {
                const updatedUser = { ...userData };
                setUserData(updatedUser);
                localStorage.setItem('userData', btoa(JSON.stringify(updatedUser)));
                enqueueSnackbar("Profile updated successfully!", { variant: "success" });
                setIsDisable(true);
            }
        } catch (error) {
            console.error("Profile Update Error:", error);
            enqueueSnackbar("Error updating profile. Please try again.", { variant: "error" });
        }
    };
    const logOut = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
        window.location.reload();
    }

    const [enquiries, setEnquiries] = useState([]);

    useEffect(() => {
        const fetchEnquiries = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/enquiry/user/${userData?.id}`);
                setEnquiries(response.data.data);
            } catch (err) {
                console.log(err.response?.data?.error)
                // enqueueSnackbar(err.response?.data?.error || "Something went wrong", { variant: "error" });
            }
        };

        fetchEnquiries();
    }, [userData?.id]);

    return (
        <div className='container mt-3'>
            <div className='row justify-content-center'>
                <div className='col-md-10'>
                    <Tabs variant="pills" defaultActiveKey="profile" id="justify-tab-example" className="mb-3 tabshistory" justify>
                        <Tab eventKey="profile" title="Profile">
                            <div className='bg-white border rounded-2 p-4 mb-3'>
                                <div className='d-md-flex align-items-center text-center'>
                                    <div className='border mx-auto d-table d-md-block mx-md-1 rounded-2'>
                                        <img className="rounded-2" src={userData?.photo_url || "https://placehold.jp/150x150.png"} alt="Profile" width={100} />
                                    </div>
                                    <div className='ms-4 mt-3 mt-md-0'>
                                        <h6>Add your profile photo, full name, and other details to help us communicate with you better.</h6>
                                        <div className='d-md-flex mt-4'>

                                            <div className="d-inline-block position-relative">
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    className="fileinpute"
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                    onChange={handleFileChange}
                                                />
                                                <button
                                                    className="btnbookprimary active"
                                                    onClick={handleFileClick}
                                                    disabled={uploading}
                                                >
                                                    {uploading ? "Uploading..." : "Add Profile Picture"}
                                                </button>
                                            </div>
                                            <button onClick={addprofile} className='btnbookprimary mt-2 mt-md-0 mx-md-3 mx-auto '>Add Profile Details</button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className='bg-white border rounded-2 p-4'>
                                <Form onSubmit={handleSubmit} >
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <Form.Group className="mb-3" controlId="display_name">
                                                <Form.Label className='fw-bold'>Full Name </Form.Label>
                                                <Form.Control autoComplete="new-password" disabled={isdisable} type="text" name="display_name" value={userData.display_name} onChange={handleChange} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-6'>
                                            <Form.Group className="mb-3" controlId="mobile">
                                                <Form.Label className='fw-bold'>Mobile No</Form.Label>
                                                <Form.Control autoComplete="new-password" disabled={isdisable} type="text" name="mobile" value={userData?.mobile || ""} onChange={handleChange} />
                                                <div>{phoneError && <Form.Text className="text-danger">{phoneError}</Form.Text>}</div>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-6'>
                                            <Form.Group className="mb-3" controlId="email">
                                                <Form.Label className='fw-bold'>Email </Form.Label>
                                                <Form.Control autoComplete="new-password" required disabled={isdisable} type="text" name="email" value={userData.email} onChange={handleChange} />
                                                <div>{emailError && <Form.Text className="text-danger">{emailError}</Form.Text>}</div>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-6'>
                                            <Form.Group className="mb-3" controlId="state">
                                                <Form.Label className='fw-bold'>State</Form.Label>
                                                <Form.Control autoComplete="new-password" disabled={isdisable} type="text" name="state" value={userData.state} onChange={handleChange} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-6'>
                                            <Form.Group className="mb-3" controlId="pincode">
                                                <Form.Label className='fw-bold'>Pincode </Form.Label>
                                                <Form.Control autoComplete="new-password" disabled={isdisable} type="number" name="pincode" value={userData.pincode} onChange={handleChange} />
                                            </Form.Group>
                                        </div>
                                        {!isdisable && <div className='col-md-2'>
                                            <Button variant="dark" className='w-100' type="submit">
                                                SAVE
                                            </Button>
                                        </div>
                                        }
                                    </div>
                                </Form>
                            </div>
                        </Tab>
                        <Tab eventKey="MyEnquiries" title="My Enquiries">
                            <div className='bg-white border rounded-2 p-4 mb-3'>
                                <div className='table-responsive'>
                                    <table className='table table-bo'>
                                        <thead>
                                            <tr>
                                                <th>S.No.</th>
                                                <th style={{ minWidth: "200px" }}>Car Name</th>
                                                <th style={{ minWidth: "200px" }}>Details</th>
                                                <th style={{ minWidth: "150px" }}>Enquiry Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {enquiries.length > 0 ? (
                                                enquiries.map((enquiry, index) => (
                                                    <tr key={enquiry.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{enquiry.package || "N/A"}</td>
                                                        <td>Booked from {enquiry.fromdate} to {enquiry.todate}</td>
                                                        <td>{enquiry.status || "Pending"}</td>
                                                        <td>
                                                            {/* <button className="btn btn-primary btn-sm">View</button> */}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No enquiries found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                    <div className='my-3 text-center d-flex justify-content-center'>
                        <button onClick={logOut} className='btnbookprimary px-5 '><i className="bi bi-power pe-2 fs-6"></i> Logout</button>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Profile;
